/**
 * Fotografias do espaço físico da Oficina da Mente.
 * Usadas na secção "O Nosso Espaço" da página inicial.
 */

export interface SpacePhoto {
  src: string;
  alt: string;
}

export const spacePhotos: SpacePhoto[] = [
  {
    src: "images/espaco-entrada.jpg",
    alt: "Entrada da Oficina da Mente com porta de vidro e logótipo",
  },
  {
    src: "images/espaco-2.jpg",
    alt: "Sala de formação da Oficina da Mente com mesas, cadeiras e luz natural",
  },
  {
    src: "images/espaco-atendimento.jpg",
    alt: "Pedro de Freitas na sala de consultas da Oficina da Mente",
  },
];
